<template>
    <div>
        <NavItem></NavItem>
        <Banner>
            <p slot="title">新闻</p>
            <p slot="s-title">NEWS</p>
        </Banner>      
        <el-tabs v-model="activeName" class="i-nav" v-if="!userAgent"  @tab-click="tabClick">
            <el-tab-pane label="大闸蟹新闻" name="1">
                <div class="content" v-for="(item,index) of data" :key="item.id">
                    <div class="f-flex n-content">
                        <div>
                            <img :src="item.image" alt="">
                        </div>
                        <div class="n-m-content">
                            <p>{{item.title}}</p>
                            <p>讲{{item.describe}}</p>
                        </div>
                        <div class="n-m-time">
                            <p>发布时间：{{item.createtime}}</p>
                            <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                        </div>
                    </div>                
                </div>
                
            </el-tab-pane>
            <el-tab-pane label="大闸蟹知识" name="2">
                <div class="content" v-for="(item,index) of data" :key="item.id">
                    <div class="f-flex n-content">
                        <div>
                            <img :src="item.image" alt="">
                        </div>
                        <div class="n-m-content">
                            <p>{{item.title}}</p>
                            <p>讲{{item.describe}}</p>
                        </div>
                        <div class="n-m-time">
                            <p>发布时间：{{item.createtime}}</p>
                            <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                        </div>
                    </div>          
                </div>
            </el-tab-pane>
            <el-tab-pane label="大闸蟹文化" name="3">
               <div class="content" v-for="(item,index) of data" :key="item.id">
                    <div class="f-flex n-content">
                        <div>
                            <img :src="item.image" alt="">
                        </div>
                        <div class="n-m-content">
                            <p>{{item.title}}</p>
                            <p>讲{{item.describe}}</p>
                        </div>
                        <div class="n-m-time">
                            <p>发布时间：{{item.createtime}}</p>
                            <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                        </div>
                    </div>          
                </div>
            </el-tab-pane>
            <el-tab-pane label="大闸蟹视频" name="4">
                <div class="content" v-for="(item,index) of data" :key="item.id">
                    <div class="f-flex n-content">
                        <div>
                            <img :src="item.image" alt="">
                        </div>
                        <div class="n-m-content">
                            <p>{{item.title}}</p>
                            <p>讲{{item.describe}}</p>
                        </div>
                        <div class="n-m-time">
                            <p>发布时间：{{item.createtime}}</p>
                            <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                        </div>
                    </div>          
                </div>
            </el-tab-pane>
            <el-pagination
                @current-change="getPage"
                background
                layout="prev, pager, next"
                :total="total_data" :page-size="5" :current-page="page">
            </el-pagination>
        </el-tabs>
        <el-tabs v-model="activeName" class="i-nav1" @tab-click="tabClick" v-else>
            <el-tab-pane label="大闸蟹新闻" name="1">
               <div class="content1" v-for="(item,index) of data" :key="item.id">
                    <div class="n-content1">
                        <div class="f-flex img">
                            <div>
                                <img :src="item.image" alt="">
                            </div>
                            <div class="n-m-time1">
                                <p>发布时间：{{item.createtime}}</p>
                                <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                            </div>
                        </div>               
                        <div class="n-m-content1">
                            <p>{{item.title}}</p>
                            <p>{{item.describe}}</p>
                        </div>
                    </div>
               </div>
            </el-tab-pane>
            <el-tab-pane label="大闸蟹知识" name="2">
                <div class="content1" v-for="(item,index) of data" :key="item.id">
                    <div class="n-content1">
                        <div class="f-flex img">
                            <div>
                                <img :src="item.image" alt="">
                            </div>
                            <div class="n-m-time1">
                                <p>发布时间：{{item.createtime}}</p>
                                <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                            </div>
                        </div>               
                        <div class="n-m-content1">
                            <p>{{item.title}}</p>
                            <p>{{item.describe}}</p>
                        </div>
                    </div>
               </div>
            </el-tab-pane>
            <el-tab-pane label="大闸蟹文化" name="3">
               <div class="content1" v-for="(item,index) of data" :key="item.id">
                    <div class="n-content1">
                        <div class="f-flex img">
                            <div>
                                <img :src="item.image" alt="">
                            </div>
                            <div class="n-m-time1">
                                <p>发布时间：{{item.createtime}}</p>
                                <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>

                            </div>
                        </div>               
                        <div class="n-m-content1">
                            <p>{{item.title}}</p>
                            <p>{{item.describe}}</p>
                        </div>
                    </div>
               </div>
            </el-tab-pane>
            <el-tab-pane label="大闸蟹视频" name="4">
                <div class="content1" v-for="(item,index) of data" :key="item.id">
                    <div class="n-content1">
                        <div class="f-flex img">
                            <div>
                                <img :src="item.image" alt="">
                            </div>
                            <div class="n-m-time1">
                                <p>发布时间：{{item.createtime}}</p>
                                <button @click="handleDetail(item.id,item.newcontent,item.title,index)">查看详情</button>
                            </div>
                        </div>               
                        <div class="n-m-content1">
                            <p>{{item.title}}</p>
                            <p>{{item.describe}}</p>
                        </div>
                    </div>
               </div>
            </el-tab-pane>
            <el-pagination
                @current-change="getPage"
                background
                layout="prev, pager, next"
                :total="total_data" :page-size="5" :current-page="page">
            </el-pagination>
        </el-tabs>      
        
    </div>
</template>
<script>
    export default {
        name:"News",
        data() {
            return {
                activeName:'1',
                data:"",
                total_data:0,
                current_page:"",
                page:1
            }
        },
        watch: {
            $route: {
            handler() {             
                this.activeName ="";
            },
            deep: true,
            },
        },
        mounted(){
            this.initData()
        },
        methods:{
            handleDetail(id,newcontent,title,index){
                 this.$router.push(`/newDetail?id=${id}&newcontent=${newcontent}&activeName=${this.activeName}&title=${title}&page=${this.page}&index=${index}`)
            },
            tabClick(tab){
                this.page=1
                this.$http.get(`/api/index/news?status=${tab.name}&page=${this.page}`).then(res => {
                    if(res.data.code==1){
                        this.data=res.data.data.data
                        this.total_data=res.data.data.total_data
                    }
                });
                
            },
            getPage(page) {
                //改变从哪一个位置开始查询
                this.page=page
                this.current_page = (this.page - 1) ;
                this.initData();
            },
            initData() {
                this.$http.get(`/api/index/news?status=${this.activeName}&page=${this.page}`).then(res => {
                    if(res.data.code==1){
                        this.data=res.data.data.data
                        this.total_data=res.data.data.total_data
                    }
                });
            },
        }
    }
</script>
<style scoped>

.n-content{
    width: 80%;
    padding: 1% 0;
    color: #4A4A4A;
    margin: 0 auto;
}
.n-content>div:nth-child(1){
    width: 8rem;
    height: 5rem;
}
.n-content>div:nth-child(1) img{
    width: 100%;
    height: 100%;
}
.n-m-content{
    width: 30%;
    margin: 0 20px;
    font-size: 16px;
    line-height: .625rem;
    
}
.n-m-content p:nth-child(1){
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin:4% 0;
}
.n-m-content p:nth-child(2){
    display: -webkit-box;overflow : hidden;text-overflow: ellipsis;-webkit-line-clamp: 5;-webkit-box-orient: vertical;
}
.n-m-time{
    width: 20%;
    height: 100%;
    text-align: center;
    flex: 2;
    font-size: 18px;
    margin-top:5%;
   
}
 .n-m-time button{
    width:150px;
    height: 40px;
    font-size: 18px;
    background-color: #A90001;
    color: white;
    border: none;
    margin-top: 20px;
    outline: none;
    cursor: pointer;
}
.i-container {
    height: 100%;
    background-color: white;
}
.i-nav /deep/ .el-tabs__header{
    width: 80%;
    height:80px ;
    line-height: 80px;
    margin: 0 auto;
}
.i-nav /deep/.el-tabs__item{
    font-weight: bold;
    font-size: 20px;
    padding: 0 50px;
}
/deep/ .el-tabs__active-bar{
      background-color: #C94032;
  }
/deep/.el-tabs__item.is-active,/deep/.el-tabs__item:hover{
      color: #C94032;
  }

/deep/ .el-tabs__content{
    background: #fff;
}
.el-pagination{
    text-align: center;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #C94032;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #C94032;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active:hover{
    color: #C94032;
}
/deep/.el-pager li.active:hover{
    color: #C94032;
}
/* 移动端 */

.content1{
    margin: 3% 0;
}
.n-content-left{
    width: 50%;
}
.n-content1{
    width: 95%;
    padding: 2% 0;
    color: #4A4A4A;
    margin: 0 auto;
    border-bottom: 1px solid  #cccccc;
    margin-top: 10px;
    align-items: center;
}
.n-content1 .img{
    width: 100%;
    align-items: center;
}
.n-content1 .img div{
    width: 150px;
    height: 100px;
}
.n-content1 .img div img{
    width: 100%;
    height: 100%;
}
.n-content-left div:nth-child(1){
    width: 100%;
}
.n-content-left img{
    width: 100%;
}
.n-m-content1{
    width: 100%;
}
.n-m-content1 p:nth-child(1){
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    margin: 5% 0;

}
.n-m-content1 p:nth-child(2){
    font-size: 12px;
    line-height: 0.5rem;
    display: -webkit-box;
    overflow : hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.n-m-time1{
    width: 20%;
    height: 100%;
    text-align: center;
    flex: 2;
    font-size: 14px;
}
.n-m-time1 p{
    margin: 5% 0;
    line-height: 20px;
}
 .n-m-time1 button{
    height: 35px;
    font-size: 14px;
    background-color: #A90001;
    color: white;
    border: none;
    outline: none;
}

.i-nav1 /deep/ .el-tabs__header{
    width: 100%;
    margin: 0 auto;
    background-color:#e9e6e6 ;
}
.i-nav1 /deep/.el-tabs__item{
    font-weight: bold;
    font-size: 12px;
    padding: 0 12px;
}
.i-nav1 /deep/ .el-tabs__nav-wrap{
    width:98%;
    padding-left:2%;
}
</style>